import { useRoleTabs } from '../../hooks/useRoleTabs';

export default function ContainerDashboard() {

    const { filteredTabs, activeTab, setActiveTab, ActiveComponent } = useRoleTabs();

    return (
        <div className="h-screen container mx-auto flex flex-col overflow-hidden pt-[64px]">
            <div className="lg:px-8 py-3 space-y-2 flex flex-col flex-1 overflow-y-auto">
                <div className='w-full bg-white rounded flex items-center justify-center'>
                    <div className='bg-white flex flex-wrap gap-2 p-2 md:p-3 rounded'>
                        {filteredTabs.map((tab) => (
                            <button
                                onClick={() => setActiveTab(tab.tabId)}
                                key={tab.tabId}
                                className={`relative flex space-x-1.5 text-sm px-3 py-1.5 rounded font-medium transition-all
                                ${activeTab === tab.tabId ? 'bg-cbColor text-white' : 'bg-gray-200 text-black'}`}
                            >
                                <span>{tab.tabName}</span>
                            </button>
                        ))}
                    </div>
                </div>
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    )
}
